import type { EphemerisAdapter } from './adapter.js';
import { AstronomyEngineAdapter } from './astronomyEngine.js';

export type { EclipticState, EphemerisAdapter } from './adapter.js';
export { AstronomyEngineAdapter, meanLunarNode, meanObliquity } from './astronomyEngine.js';

let defaultAdapter: EphemerisAdapter | null = null;

export function getDefaultAdapter(): EphemerisAdapter {
  if (!defaultAdapter) defaultAdapter = new AstronomyEngineAdapter();
  return defaultAdapter;
}

/** Swap the ephemeris implementation globally (e.g. Swiss Ephemeris later). */
export function setDefaultAdapter(adapter: EphemerisAdapter): void {
  defaultAdapter = adapter;
}
